import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 450px;
    width: 100%;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 450px !important;
    place-content: center;
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;

  svg {
    color: #fff;
    cursor: pointer;
    margin-left: 10px;
  }
`;

export const ModalContent = styled.a`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;

  img {
    width: 100%;
  }
`;

export const ButtonCTO = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  width: 100%;
  background-color: ${({ theme }) => theme?.colors?.blue};
  color: #fff;
  font-size: 18px;
  font-family: "Mangueira bold";
  cursor: pointer;
`;
